import {en_GB, pl_PL} from './definitions/definitions/index'

export const getLocaleDefinition = (locale) => {
    switch (locale) {
        case 'en_US':
            return ['en', en_GB];
        default:
            return ['pl', pl_PL];
    }
};